import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";
import errorHandler from '../common/errorHandler';

Vue.use(Toast);

//创建axios实例对象 
const instance = axios.create({
    baseURL: 'https://www.yuepaoba6.com/api',
    timeout: 10000,
    retry: 3,
    retryDelay: 1000,
})

//请求拦截器
instance.interceptors.request.use(config=>{
    // ✅ 强制设置语言头
    const languageMap = {
        'ko': 'ko-KR',
        'zh-CN': 'zh-CN', 
        'en': 'en-US',
        'jp': 'ja-JP',
        // 新增语言映射
        'vi': 'vi-VN',    // 越南语
        'hi': 'hi-IN',    // 印地语  
        'th': 'th-TH',    // 泰语
        'ru': 'ru-RU'     // 俄语
    }
    const currentLanguage = localStorage.getItem('change-language') || 'zh-CN';
    const backendLanguage = languageMap[currentLanguage] || 'zh-CN';
    
    
    // ✅ 先设置基础headers（强制包含语言头）
    config.headers = {
        'Accept-Language': backendLanguage, // 强制添加语言头
        ...config.headers // 合并其他headers
    }
    
    if(config.method === "post"){
        config.headers = {
            ...config.headers,  // 保留语言头
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        }
    }
    if(localStorage.getItem('token')){
        config.headers = {
            ...config.headers,  // 保留语言头
            'token': Base64.encode(localStorage.getItem('token')),
        }
    }
    
    // ✅ 调试信息
    console.log('🚀 最终请求头:', config.headers);
    console.log('🌐 设置的语言头:', backendLanguage);
    
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    if(res.data.msg === "鉴权错误"){
        localStorage.clear();
        // 注意：这里可能需要修改路由跳转方式
        if (window.location.pathname !== '/Login') {
            window.location.href = '/Login';
        }
    }
    return res
},err=>{
    console.error('HTTP请求错误:', err);
    
    if (err.code === 'NETWORK_ERROR' || err.message.includes('ERR_CONNECTION_CLOSED')) {
        Toast.fail('网络连接失败，请检查网络设置');
    } else if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
        Toast.fail('请求超时，请稍后重试');
    } else if (err.response && err.response.status >= 500) {
        Toast.fail('服务器错误，请稍后重试');
    }
    
    return Promise.reject(err);
})

//封装axios请求方法
async function http(option = {}) {
    const maxRetries = option.retry || 3;
    const retryDelay = option.retryDelay || 1000;
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            let result = null;
            
            if(option.method === 'get' || option.method === 'delete'){
                const response = await instance[option.method](
                    api[option.url],
                    {params: option.data}
                );
                result = response.data;
                result.data = JSON.parse(Base64.decode(result.data));
            }else if(option.method === 'post' || option.method === 'put'){
                const response = await instance[option.method](
                    api[option.url],
                    qs.stringify(option.data)
                );
                result = response.data;
                result.data = JSON.parse(Base64.decode(result.data));
            }
            
            return result;
            
        } catch (err) {
            console.warn(`HTTP请求失败 (第${attempt}次):`, err.message);
            errorHandler.handleApiError(err, option.url);
            
            if (attempt === maxRetries) {
                console.error('HTTP请求最终失败:', err);
                return err;
            }
            
            await new Promise(resolve => setTimeout(resolve, retryDelay * attempt));
        }
    }
}

export default http


